import React from "react";
import { connect } from "react-redux";
import NuevaGestionColumnaIzq from './nuevaGestionColumnaIzq'
import NuevaGestionColumnaDer from "./nuevaGestionColumnaDer"
import {reserveScheduling} from "../actions"

class nuevaGestionSolicitudes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {    
      workerSelected: null,      
    };
  }

  handleWorkerSelected = (data) => {
    this.setState({workerSelected: data})
  }

  handleSchedulingSelected = async (cupo, idOffice, currentDate, typeAmount) => {  
    if(this.props.isLoading) return false;
    await this.props.dispatch(reserveScheduling(this.state.workerSelected, cupo, this.props.selectedSolicitud, 4, idOffice, currentDate, this.props.userData.RUT, typeAmount, this.props.connectionHub))
  }

  render() {
    return (
      <React.Fragment>
        <div className={'row contenedorNuevaGestionSolicitud'}>
          <div className="col-3 columnaIzquierda">
            <NuevaGestionColumnaIzq 
              connectionHub={this.props.connectionHub}
              close={()=>this.props.close()}
              onWorkerSelected={this.handleWorkerSelected}
            />           
          </div>
          <div className="col-9 columnaDerecha">
            <NuevaGestionColumnaDer 
              onSchedulingSelected={this.handleSchedulingSelected}
              connectionHub={this.props.connectionHub}
              close={()=>this.props.close()}
            />
          </div>            
        </div>
      </React.Fragment>
    );
  }
}


const mapStateToProps = (state) => ({
  isLoading: state.inboxSolicitudes.isLoading,
  companyId: state.global.companyId,
  sucursalId: state.global.sucursalId,
  userData: state.global.userData,
  selectedSolicitud: state.inboxSolicitudes.selectedSolicitud,
  dataGridCupos: state.inboxSolicitudes.dataGridCupos,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(nuevaGestionSolicitudes);

